export function modalFunc() {
  const openModal = (modal) => {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-modal-open');
  };

  const closeModal = (modal) => {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-modal-open');

    // 動画は閉じたら停止（src を空に）
    const iframe = modal.querySelector('[data-movie-iframe]');
    if (iframe) iframe.src = '';

    // コメント画像は閉じたらクリア（次回オープン時の前画像チラつき防止）
    const commentImg = modal.querySelector('[data-modal-img-el]');
    if (commentImg) {
      commentImg.hidden = true;
      commentImg.removeAttribute('src');
    }
  };

  // コメントモーダル
  const commentModal = document.getElementById('castCommentModal');
  if (commentModal) {
    const elRole = commentModal.querySelector('[data-modal-role]');
    const elName = commentModal.querySelector('[data-modal-name]');
    const elNote = commentModal.querySelector('[data-modal-note]');
    const elText = commentModal.querySelector('[data-modal-text]');
    const elImg = commentModal.querySelector('[data-modal-img-el]');

    document.querySelectorAll('[data-modal-open="comment"]').forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();

        // 前回画像が一瞬見えるのを防ぐため、表示前に必ずクリア
        elImg.hidden = true;
        elImg.removeAttribute('src');

        const staff = trigger.closest('.p-home-cast__staff');
        const role = staff ? (staff.querySelector('.p-home-cast__staff-role')?.textContent || '').trim() : '';
        const name = staff ? (staff.querySelector('.p-home-cast__staff-name-main')?.textContent || '').trim() : '';
        const note = staff ? (staff.querySelector('.p-home-cast__staff-note')?.textContent || '').trim() : '';
        const text = trigger.dataset.commentText || '';
        const imgSrc = trigger.dataset.commentImg || '';
        const hasImage = trigger.dataset.commentHasImage === 'true' || imgSrc !== '';

        elRole.textContent = role;
        elName.textContent = name;

        if (note) {
          elNote.textContent = note;
          elNote.hidden = false;
        } else {
          elNote.textContent = '';
          elNote.hidden = true;
        }

        elText.innerHTML = '';
        text.split(/\n+/).forEach((para) => {
          const trimmed = para.trim();
          if (!trimmed) return;
          const p = document.createElement('p');
          p.textContent = trimmed;
          elText.appendChild(p);
        });

        const openCommentModal = () => openModal(commentModal);

        if (hasImage) {
          commentModal.classList.add('is-has-image');
          if (imgSrc) {
            const preload = new Image();
            preload.onload = () => {
              elImg.src = imgSrc;
              elImg.hidden = false;
              openCommentModal();
            };
            preload.onerror = openCommentModal;
            preload.src = imgSrc;
            return;
          }
        } else {
          commentModal.classList.remove('is-has-image');
        }

        openCommentModal();
      });
    });
  }

  // 動画モーダル
  const movieModal = document.getElementById('movieModal');
  if (movieModal) {
    const iframe = movieModal.querySelector('[data-movie-iframe]');

    document.querySelectorAll('[data-modal-open="movie"]').forEach((trigger) => {
      const open = (e) => {
        e.preventDefault();
        const src = trigger.dataset.movieSrc || '';
        if (iframe && src) iframe.src = src;
        openModal(movieModal);
      };
      trigger.addEventListener('click', open);
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') open(e);
      });
    });
  }

  // 閉じる操作（共通）
  // ・閉じるボタン
  // ・モーダルボックスの外側（オーバーレイ／余白）クリック
  document.querySelectorAll('.c-modal').forEach((modal) => {
    const box = modal.querySelector('.c-modal__body, .c-modal-movie');
    modal.addEventListener('click', (e) => {
      if (box && box.contains(e.target)) return;
      closeModal(modal);
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.c-modal.is-open').forEach((modal) => closeModal(modal));
  });
}
